import FixedTermMaturityType from "@/models/Products/ProductSettings/DefaultSettings/FixedTermMaturity/FixedTermMaturityType";

export default (action: FixedTermMaturityType) => {
    let returnVal = "Undefined";
    switch (action) {
        case FixedTermMaturityType.ReinvestFullBalance:
            returnVal = "Reinvest Full Balance";
            break;
        case FixedTermMaturityType.FullWithdrawal:
            returnVal = "Withdraw Full Balance";
            break;
        case FixedTermMaturityType.InterestOnlyWithdrawal:
            returnVal = "Withdraw Interest Only";
            break;
        case FixedTermMaturityType.Custom:
            returnVal = "Custom";
        break;
    }
    return returnVal;
}